import 'invoiceOpenService'
import './components/invoiceFinder'
import './components/invoiceBalance'
import './components/invoiceDiscount'
import './components/invoiceGoods'
import './components/goodsAdd'
import './components/blueFinder'
import './components/toFixed'
import './components/taxrateDropdown'
import './components/privilegeDropdown'
import './components/privilegeTypeDropdown'
import './components/saleTaxrateDropdown'
import invoiceModule from './module'

import modalCopyInvoiceCtrl from './modalCopyInvoiceCtrl'
import invoiceApplicant from './invoiceApplicantComponent'

import modalFindBlueInvoiceCtrl from './modalFindBlueInvoiceCtrl'


import { invoice,ovatBill } from 'redevConfig'

const list          = (invoice && invoice.list) || ''
const add           = (invoice && invoice.add) || ''
// const addred        = (invoice && invoice.addred) || ''
// const edit          = (invoice && invoice.edit) || ''
const detail        = (invoice && invoice.detail) || ''
const relatedBill   = (invoice && invoice.relatedBill) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''

const invoiceListPage = list ? require(`redevelopment/outputManage/invoice/${list.templateName}`) : require('./view/invoiceList.html')
const invoiceListCtrl = list ? require(`redevelopment/outputManage/invoice/${list.controllerName}`) : require('./InvoiceListCtrl')

const invoiceEditPage = add ? require(`redevelopment/outputManage/invoice/${add.templateName}`) : require('./view/invoiceEdit.html')
const invoiceEditCtrl = add ? require(`redevelopment/outputManage/invoice/${add.controllerName}`) : require('./InvoiceEditCtrl')

const relatedBillPage = relatedBill ? require(`redevelopment/outputManage/invoice/${relatedBill.templateName}`) : require('./view/relatedBill_invoice.html')
const invRelatedBillCtrl = relatedBill ? require(`redevelopment/outputManage/invoice/${relatedBill.controllerName}`) : require('./invRelatedBillCtrl')

const invoiceDetailPage = detail ? require(`redevelopment/outputManage/invoice/${detail.templateName}`) : require('./view/invoiceDetail.html')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../ovatBill/view/checkBillDetailCtrl.html')


function config ($stateProvider) {
    $stateProvider.state(
        'outputManage.FOManage.invoice',
        {
            abstract: true,
            url: '/invoice',
            template: '<div ui-view></div>',
            title: '专普票开具',
            default: 'outputManage.FOManage.invoice.list',
        },
    ).state(
        'outputManage.FOManage.invoice.list',
        {
            url: '/list',
            template: invoiceListPage,
            controller: 'invoiceListCtrl',
        },
    ).state(
        'outputManage.FOManage.invoice.add',
        {
            url: '/add/:invType',
            template: invoiceEditPage,
            controller: 'invoiceEditCtrl',
            title: '新增蓝字发票',
        },
    ).state(
        'outputManage.FOManage.invoice.addred',
        {
            url: '/addRed/:invType',
            template: invoiceEditPage,
            controller: 'invoiceEditCtrl',
            title: '新增红字发票',
        },
    )
        .state(
            'outputManage.FOManage.invoice.edit',
            {
                url: '/edit/:waitId/',
                template: invoiceEditPage,
                controller: 'invoiceEditCtrl',
                title: '编辑发票',
                params: {
                    pagingFlag: true,
                },
            },
        )
        .state(
            'outputManage.FOManage.invoice.detail',
            {
                url: '/detail/:waitId',
                template: invoiceDetailPage,
                controller: 'invoiceEditCtrl',
                title: '发票详情',
                params: {
                    detailFlag: true,
                },
            },
        )
        .state(
            'outputManage.FOManage.invoice.relatedBill',
            {
                url: '/relatedBill/:waitId',
                template: relatedBillPage,
                controller: 'invRelatedBillCtrl',
                title: '关联销售单',
            },
        )
        .state(
            'outputManage.FOManage.invoice.checkBillDetail',
            {
                url: '/checkBillDetail/:billId',
                template: checkBillDetailCtrl,
                controller: 'checkBillDetailCtrl',
                title: '销售单明细',
            },
        )
}

export default invoiceModule.config(['$stateProvider', config])
    .controller('invoiceListCtrl', invoiceListCtrl.default)
    .controller('invoiceEditCtrl', invoiceEditCtrl.default)
    .controller('modalCopyInvoiceCtrl', modalCopyInvoiceCtrl)
    .controller('invRelatedBillCtrl', invRelatedBillCtrl.default)
    .controller('modalFindBlueInvoiceCtrl', modalFindBlueInvoiceCtrl)
    .component('invoiceApplicant', invoiceApplicant)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/index.js